"use client"

import * as React from "react"
import Link from "next/link"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"

import { requestPasswordReset } from "@/lib/api/client/password"
import { forgotPasswordSchema, type ForgotPasswordValues } from "@/lib/password/schemas"
import { Button } from "@/components/ui/button"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import * as m from "@/paraglide/messages"

export function ForgotPasswordForm() {
  const form = useForm<ForgotPasswordValues>({ resolver: zodResolver(forgotPasswordSchema), defaultValues: { email: "" } })
  const [requestError, setRequestError] = React.useState(false)
  const submitted = form.formState.isSubmitSuccessful

  const onSubmit = form.handleSubmit(async (values) => {
    setRequestError(false)
    try {
      await requestPasswordReset(values)
    } catch {
      // Transport/provider errors are not account-existence signals.
      setRequestError(true)
      return
    }
    form.reset(values)
  })

  if (submitted && !requestError) {
    return <div className="grid gap-4"><p role="status" aria-live="polite">{m.password_forgot_success()}</p><Link href="/login" className="text-sm font-medium text-primary underline-offset-4 hover:underline">{m.password_back_to_login()}</Link></div>
  }

  return <Form {...form}><form onSubmit={onSubmit} className="grid gap-4" noValidate>
    {requestError ? <p role="alert">{m.password_forgot_error_generic()}</p> : null}
    <FormField control={form.control} name="email" render={({ field }) => <FormItem><FormLabel>{m.login_email_label()}</FormLabel><FormControl><input type="email" autoComplete="email" placeholder={m.login_email_placeholder()} className="h-10 w-full rounded-md border bg-background px-3" {...field} /></FormControl><FormMessage /></FormItem>} />
    <Button type="submit" disabled={form.formState.isSubmitting}>{form.formState.isSubmitting ? m.password_forgot_submitting() : m.password_forgot_submit()}</Button>
    <Link href="/login" className="text-center text-sm text-primary underline-offset-4 hover:underline">{m.password_back_to_login()}</Link>
  </form></Form>
}
